import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import VariantHelper from '../utils/VariantHelper';
import Select from './Select';

function updateCart() {
  window.Shopify.getCart((cart) => {
    // Returned from GET call
    const newFormattedAmount = window
      .Shopify
      .formatMoney(cart.total_price, window.Theme.moneyFormat);

    // Update cart text
    $('.cart-item-count-wrap').text(`(${cart.item_count})`);
    const $newAmount = $('.cart-amount-wrap').html(newFormattedAmount);

    if (CurrencyConverter.isInitialised && $newAmount.length) {
      CurrencyConverter.update($newAmount[0]);
    }
  });
}

export default class QuickShop {
  constructor({ el }) {
    this.$el = $(el);
    // a single modal is used for all quickshops, so these are intentionally unscoped.
    this.quickShopModal = $('.quick-shop-modal');
    this.quickShopConfirmation = $('.quick-shop-confirmation');
    this.minimumPriceArea = $('.quick-shop-price-minimum');
    this._bindEvents();
    this.addingToCart = false;
    this.open = false;
  }

  _bindEvents() {
    this.events = [
      $('.product-item-quick-shop .available', this.$el).on('click.quickshop', e => this.openQuickShop(e)),
      $('.quick-shop-add', this.$el).on('click.quickshop', e => this.addToCart(e)),
      $('.quick-shop-modal').on('click.quickshop touchstart.quickshop', e => this.onModalClick(e)),
      $('.quick-shop-close').on('click.quickshop touchstart.quickshop', e => this.closeQuickShop()),
      $('.quick-shop-close-x', this.$el).on('click.quickshop touchstart.quickshop', e => this.closeQuickShop()),
    ];
  }

  _unbindEvents() {
    this.events.forEach($event => $event.off('.quickshop'));
  }

  openQuickShop(e) {
    e.preventDefault();
    this.open = true;
    const $target = $(e.currentTarget);
    this.product = $target.data('product-json');
    this.enableCartRedirection = $target[0].hasAttribute('data-quickshop-enable-cart-redirection');
    this.itemId = $target.data('quickshop-id');
    this.sectionId = $target.data('section-id');
    this.$quickShopContent = $(`#quick-shop-${this.sectionId}-${this.itemId}`);

    this.setupVariants(this.$quickShopContent);
    $('select', this.$el).each((index, select) => new Select({ el: select }));

    this.quickShopModal.addClass('visible').append(this.$quickShopContent);
    setTimeout(() => {
      this.quickShopModal.addClass('active');
      this.$quickShopContent.addClass('active');
      $(document.body).addClass('quick-shop-open');
    },
    20);

    this.positionQuickShop(this.$quickShopContent);

    window.Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  onModalClick(e) {
    // Handle click event to close the modal but reject actual Quick Shop elements
    if (e && !$(e.target).closest('.quick-shop-container').length && !$(e.target).closest('.product-item-quick-shop').length) {
      this.closeQuickShop();
    }
  }

  closeQuickShop(options = {}) {
    if (!this.open) {
      return;
    }

    this.quickShopModal.removeClass('active').one('transitionend', () => {
      this.addingToCart = false;
      this.open = false;

      if (options.clearErrors) {
        $('.quick-shop-message').remove();
      }

      this.quickShopModal.removeClass('visible');
      this.$quickShopContent.removeClass('active');
      this.quickShopConfirmation.removeClass('active');
      $(document.body).removeClass('quick-shop-open');

    });
  }

  showCartConfirmation() {
    this.$quickShopContent.removeClass('active').one('transitionend', () => {
      this.quickShopConfirmation.addClass('active');
    });
  }

  setupVariants(quickShopContent) {
    this.$quickShopContent = quickShopContent;
    const $quickShopForm = $('.quickshop-form', this.$quickShopContent);
    this.quickshopformID = parseInt($quickShopForm.attr('data-quickshop-form'), 10);
    const $priceArea = $('.quick-shop-price-container', this.$quickShopContent);
    const $addToCartButton = $('.quick-shop-add', this.$quickShopContent);

    const $productJSON = $(`[data-quickshop-json-${this.quickshopformID}]`, this.$quickShopContent);
    const $productSettings = $(`[data-quickshop-settings-${this.quickshopformID}]`, this.$quickShopContent);
    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());

    const $variantDropdowns = $(`[data-option-select=${this.quickshopformID}]`, this.$quickShopContent);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;

    if (!$variantDropdowns.length) { return; }

    const dropdownSettings = {
      $addToCartButton,
      $priceFields: $priceArea,
      $productForm: $quickShopForm,
      $selector: $variantDropdowns,
      formID: this.quickshopformID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      type: 'select',
    };

    this.variantHelpers = new VariantHelper(dropdownSettings);
  }

  addToCart(e) {
    if (this.enableCartRedirection) {
      return;
    }
    e.preventDefault();

    if (this.addingToCart === true) { return; }

    const formId = `product-form-${this.sectionId}-${this.quickshopformID}`;
    const $form = $(`#${formId}`);
    const formData = $form.serialize();
    if (formData === '') { return; }

    e.preventDefault();

    const button = $form.find('.quick-shop-add');

    if (!button.children().hasClass('disabled')) {
      this.addingToCart = true;

      window.Shopify.addItemFromForm(formId, (item) => {
        updateCart(item);
        this.showCartConfirmation();
      });
    }
  }

  positionQuickShop(quickShop) {
    const quickShopHeight = quickShop.outerHeight();
    quickShop.css({ marginTop: quickShopHeight / -2 });

    const quickShopConfirmationHeight = this.quickShopConfirmation.outerHeight();
    this.quickShopConfirmation.css({ marginTop: quickShopConfirmationHeight / -2 });
  }

  handleErrors(error) {
    this.$quickShopContent
      .append(`\
<div class="quick-shop-message">
  ${error.responseJSON.description}
</div>\
`);

    setTimeout(() => {
      this.closeQuickShop({clearErrors: true});
      this.addingToCart = false;
    },
    1000);
  }

  unload() {
    this._unbindEvents();
  }
}
